import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@mui/material";
export function EnableAutoWrapPreview({ command: cmd, }) {
    return (_jsx(Typography, { component: "pre", variant: "body2", children: JSON.stringify(cmd, null, 2) }));
}
